type TSearchFeedField = 'content'

type TSearchDocumentField = 'name'

const searchShipmentFieldLabels: Record<string, string> = {
  carrier_id: 'search-shipment-carrier_id',
  container_number: 'search-shipment-container_number',
  customer_reference: 'search-shipment-customer_reference',
  container_customer_reference: 'search-shipment-container_customer_reference',
  destination: 'search-shipment-destination',
  id: 'search-shipment-id',
  mode: 'search-shipment-mode',
  origin: 'search-shipment-origin',
  pod: 'search-shipment-pod',
  pol: 'search-shipment-pol',
  type: 'search-shipment-type',
  vessel: 'search-shipment-vessel',
  shipper_contact_name: 'search-shipper-contact-name',
  consignee_contact_name: 'search-consignee-contact-name',
  invoice_number: 'search-invoice_number',
  atc_number: 'search-atc_number',
}

const searchFeedFieldLabels: Record<TSearchFeedField, string> = {
  content: 'search-feed-content',
}

const searchDocumentFieldLabels: Record<TSearchDocumentField, string> = {
  name: 'search-feed-document_name',
}

export const searchFieldLabels = {
  ...searchFeedFieldLabels,
  ...searchShipmentFieldLabels,
  ...searchDocumentFieldLabels,
}
